export default {
    methods: {
        sortAlphabeticallyAsc (data) {
            return Array.from (data).sort ((a, b) => {
                if (!a.title) {
                    return 1
                }

                if (!b.title) {
                    return -1
                }

                return a.title.localeCompare (b.title)
            })
        }
    }
}
